import React, { createContext, Dispatch, SetStateAction } from 'react'
import { SubmitHandler, UseFormReturn } from 'react-hook-form'
import { BaseErrorResponse } from 'types/beneficiaries'
import {
  ExportTabItemsType,
  RecurringExportForm,
  RecurringExportStepsType,
  ReportSchedule,
} from 'types/transactionsExport'

export interface RecurringExportContextValue {
  walletId: string | undefined
  step: RecurringExportStepsType
  createReportSchedule: SubmitHandler<RecurringExportForm>
  updateReportSchedule: SubmitHandler<RecurringExportForm>
  setStep: Dispatch<SetStateAction<RecurringExportStepsType>>
  form: UseFormReturn<RecurringExportForm, unknown, undefined>
  handleClose: () => void
  currentReportSchedule: ReportSchedule
  setCurrentReportSchedule: Dispatch<SetStateAction<ReportSchedule>>
  setOpenTab: React.Dispatch<SetStateAction<ExportTabItemsType>>
  isUpdatingReportSchedule: boolean
  setIsUpdatingReportSchedule: Dispatch<SetStateAction<boolean>>
  isLoadingPostReportSchedule: boolean
  isErrorPostReportSchedule: boolean
  postReportScheduleError: BaseErrorResponse
  isLoadingPutReportSchedule: boolean
  isErrorPutReportSchedule: boolean
  putReportScheduleError: BaseErrorResponse
}

export const RecurringExportContext = createContext<RecurringExportContextValue>({
  walletId: null,
  step: null,
  createReportSchedule: () => null,
  updateReportSchedule: () => null,
  setStep: () => null,
  handleClose: () => null,
  currentReportSchedule: null,
  setCurrentReportSchedule: () => null,
  setOpenTab: () => null,
  isUpdatingReportSchedule: null,
  setIsUpdatingReportSchedule: () => null,
  form: null,
  isLoadingPostReportSchedule: null,
  isErrorPostReportSchedule: null,
  postReportScheduleError: null,
  isLoadingPutReportSchedule: null,
  isErrorPutReportSchedule: null,
  putReportScheduleError: null,
})

interface RecurringExportContextProviderProps {
  value: RecurringExportContextValue
  children: React.ReactNode
}

export const RecurringExportContextProvider = ({
  children,
  value,
}: RecurringExportContextProviderProps) => {
  return <RecurringExportContext.Provider value={value}>{children}</RecurringExportContext.Provider>
}
